import { fetchSiteContent } from '../util/api';
import { storableError } from '../util/errors';
import * as log from '../util/log';

// The site's content from the admin panel: the landing page's shop links.

// ================ Action types ================ //

export const FETCH_CONTENT_REQUEST = 'app/content/FETCH_CONTENT_REQUEST';
export const FETCH_CONTENT_SUCCESS = 'app/content/FETCH_CONTENT_SUCCESS';
export const FETCH_CONTENT_ERROR = 'app/content/FETCH_CONTENT_ERROR';

// ================ Reducer ================ //

const initialState = {
  contentInProgress: false,
  contentError: null,
  shopLinks: [],
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case FETCH_CONTENT_REQUEST:
      return { ...state, contentInProgress: true, contentError: null };
    case FETCH_CONTENT_SUCCESS:
      return { ...state, contentInProgress: false, shopLinks: payload.shopLinks?.data || [] };
    case FETCH_CONTENT_ERROR:
      return { ...state, contentInProgress: false, contentError: payload };
    default:
      return state;
  }
}

// ================ Thunks ================ //

export const fetchContent = () => async dispatch => {
  dispatch({ type: FETCH_CONTENT_REQUEST });
  try {
    const response = await fetchSiteContent();
    dispatch({ type: FETCH_CONTENT_SUCCESS, payload: response });
    return response;
  } catch (error) {
    log.error(error, 'fetch-content-failed');
    dispatch({ type: FETCH_CONTENT_ERROR, payload: storableError(error), error: true });
    throw error;
  }
};
